// App.js
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSignatureData } from '../redux-toolkit/slices/signatureSlice';
import { toast } from 'react-toastify';
const boxStyle = {
  height: "100%",
  width: "100%",
  border: "1px solid #d3d3d3",
};

function FormElements({handleClose}) {
  const signer = {
    firstName: "Advocate",
    lastName: "Advocate"
  };

  const btnRestore = useRef();
  const chkB64 = useRef();
  const chkSigText = useRef();
  const firstName = useRef("");
  const lastName = useRef("");
  const imageBox = useRef();
  const txtSignature = useRef();
  const txtDisplay = useRef();
  const dispatch = useDispatch();

  const [chkValue, setChecked] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [isSignatureSaved, setIsSignatureSaved] = useState(false);

  const setRestoreButtonState = (buttonState) => {
    setChecked(buttonState);
    document.getElementById("Restore").disabled = buttonState;
  };
  const handleCapture = () => {
    const imgElement = imageBox.current.querySelector("img");
    if (imgElement) {
      const imageData = imgElement.src;
      dispatch(setSignatureData(imageData));
      console.log('Image data: handleCapture', imageData);
      toast.success('Signature is saved successfully');
      handleClose();
      

    }
  };

  useEffect(() => {
    document.getElementById("Restore").disabled = true;
  }, []);

  
  useEffect(() => {
    const imgElement = imageBox.current.querySelector("img");
    if (imgElement && imgElement.src) {
      const imageData = imgElement.src;
      dispatch(setSignatureData(imageData));
      console.log('Image data:', imageData);
    }
  }, []);

  return (
    <div className="container">
      <br /><br />
      <div className="row justify-content-center mb-2">
        <div className="col-md-10">
          <div className="row justify-content-between">
            <div className="col-sm-6">
              <div id="imageBox" ref={imageBox} style={boxStyle} title="Double-click a signature to display its details"></div>
            </div>
            <div className="col-sm-6 px-3">
              <div className="mb-2">
              <button className="btn btn-primary btn-block" title="Capture a signature" onClick={() => { window.capture(firstName.current, lastName.current, imageBox.current, txtSignature.current, chkSigText.current, chkB64.current); }}>Open SignaturePad</button>
              </div>
              <div className="mb-2">
                <button className="btn btn-success btn-block" title="Checks the signature hash" onClick={() => { handleCapture()}}>Save Signature</button>
              </div>
              <div className="mb-2 d-none">
                <button className="btn btn-primary btn-block" title="Checks the signature hash" onClick={() => (window.verifySignedData())}>Verify</button>
              </div>
              <div className="mb-2 d-none">
                <button className="btn btn-primary btn-block" title="Displays capture details of the signature" onClick={() => (window.displaySignatureDetails())}>Details</button>
              </div>
              <div className="mb-2 d-none">
                <button className="btn btn-warning btn-block" title="Displays the Help About box" onClick={() => (window.aboutBox())}>License</button>
              </div>
              <div className="mb-2">
                <button className="btn btn-danger btn-block" title="Clears the signature" onClick={() => (window.clearSignature())}>Clear</button>
              </div>
              <div className="mb-2 d-none">
                <button id="Restore" className="btn btn-warning btn-block" ref={btnRestore} title="Restores the signature from the SigText data. To use this function please tick Output SigText to form" onClick={() => (window.setSignatureText())} disabled>Restore</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center d-none">
        <div className="col-md-10">
          <div className="row justify-content-around">
            <div className="col-md-4">
              <b>Data included in the hash: </b>
              <input id="fname" className="form-control mb-2" ref={firstName} defaultValue={`${signer.firstName}`} />
              <input id="lname" className="form-control mb-4" ref={lastName} defaultValue={`${signer.lastName}`} />
            </div>
            <div className="col-md-4">
              <b>Options:</b>
              <br />
              <input type="checkbox" id="chkUseB64Image" className="form-check-input mb-2" ref={chkB64} />
              <label className="form-check-label" htmlFor="chkUseB64Image">Use base-64 signature image</label>
              <br />
              <input type="checkbox" id="chkShowSigText" className="form-check-input mb-4" onChange={() => setRestoreButtonState(chkSigText.current.checked)} ref={chkSigText} />
              <label className="form-check-label" htmlFor="chkShowSigText">Output SigText to form</label>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-10">
          <textarea className="form-control" cols="125" rows="8" id="txtDisplay" ref={txtDisplay}></textarea>
          <br />
          <div className='d-none'>
            <br />SigText:<br />
            <textarea className="form-control" cols="125" rows="15" id="txtSignature" ref={txtSignature}></textarea>
          </div>
        </div>
      </div>
    </div>
  );
}

function Signature({handleCloseSignature}) {
  useEffect(() => {
    window.bodyOnLoad(document.getElementById("txtDisplay"), document.getElementById("chkShowSigText"), document.getElementById("Restore"));
  }, []);
  return (
    <FormElements handleClose={handleCloseSignature}/>
  );
}

export default Signature;
